/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { LpMetaProps } from "../../../../../types/LpMetaProps";
import { gaSet } from "../../../../../services/googleAnalyticsService";

const LpDistancePageMeta = ({ keyword }: LpMetaProps) => {
  const title = keyword + " | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="description"
        content="Sie haben einen Abstandsverstoß begangen? Lassen Sie Ihren Bußgeldbescheid online prüfen! - Schnell, einfach und sicher!"
      />
      <meta name="keywords" content="Abstandsverstoß, Verkehrsrecht, Bußgeld, Bußgeldbescheid, Anhörungsbogen, Ordnungswidrigkeit, Fahrverbot" />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content="Sie haben einen Abstandsverstoß begangen? Lassen Sie Ihren Bußgeldbescheid online prüfen! - Schnell, einfach und sicher!"
      />
    </Helmet>
  );
};

export default LpDistancePageMeta;
